// src/pages/ComunidadPage.jsx

import React, { useState, useEffect } from 'react'; // ✅ Importamos useEffect
import { Box, Container, Heading, VStack, Icon, Spinner, Center, Text, HStack, IconButton } from '@chakra-ui/react';
import { FaComments, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { useAnnouncements } from '../hooks/useAnnouncements';
import { AnnouncementCard } from '../components/AnnouncementCard';
import { useLocation } from 'react-router-dom'; // ✅ Importamos useLocation

export default function ComunidadPage() {
  const { announcements, loading } = useAnnouncements();
  const location = useLocation(); // Hook para acceder a la URL

  // Lógica de Paginación
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(announcements.length / itemsPerPage);
  const paginatedAnnouncements = announcements.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  // ✅ EFECTO PARA HACER SCROLL AL ANUNCIO
  useEffect(() => {
    // Se ejecuta cuando los anuncios se cargan o la URL cambia
    if (!loading && location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Hacemos scroll suave hasta el elemento
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [loading, location.hash, announcements]);


  return (
    <Container maxW="container.lg" py={8}>
      <VStack spacing={8} align="stretch">
        <HStack>
          <Icon as={FaComments} w={8} h={8} color="blue.500" />
          <Heading size="xl">Anuncios del Club</Heading>
        </HStack>
        
        {loading ? <Center h="200px"><Spinner size="xl"/></Center> :
         announcements.length > 0 ? (
            <VStack spacing={8} align="stretch">
                {paginatedAnnouncements.map(anuncio => (
                    // ✅ AÑADIMOS EL ID AL CONTENEDOR DEL ANUNCIO
                    <Box key={anuncio.id} id={anuncio.id}>
                        <AnnouncementCard announcement={anuncio} />
                    </Box>
                ))}

                {totalPages > 1 && (
                    <HStack justify="center" mt={4}>
                        <IconButton
                            icon={<FaArrowLeft />}
                            aria-label="Página anterior"
                            onClick={() => setCurrentPage(p => p - 1)}
                            isDisabled={currentPage === 0}
                        />
                        <Text fontSize="sm" color="gray.600">
                            Página {currentPage + 1} de {totalPages}
                        </Text>
                        <IconButton
                            icon={<FaArrowRight />}
                            aria-label="Página siguiente"
                            onClick={() => setCurrentPage(p => p + 1)}
                            isDisabled={currentPage >= totalPages - 1}
                        />
                    </HStack>
                )}
            </VStack>
         ) : (
            <Center p={10} bg="white" borderRadius="xl" boxShadow="lg">
                <Text color="gray.600">No hay anuncios publicados por el momento.</Text>
            </Center>
         )
        }
      </VStack>
    </Container>
  );
}